import { TowerControl, RadioTower, GitMerge, Wrench, ClipboardCheck, LayoutGrid, ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { SERVICES } from "../../data/siteData";

const icons = {
  "tower-control": TowerControl,
  "radio-tower": RadioTower,
  "git-merge": GitMerge,
  wrench: Wrench,
  "clipboard-check": ClipboardCheck,
  "layout-grid": LayoutGrid,
};

const scrollTo = (e, href) => {
  e.preventDefault();
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Services = () => (
  <section id="services" className="section bg-[#081C3A]" data-testid="services-section">
    <div className="container-custom">
      <SectionHeading
        eyebrow="What We Do"
        title="End-to-End Telecommunications Capability"
        subtitle="From tower tops to fibre cores — a single, accountable partner for the full infrastructure lifecycle."
      />

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {SERVICES.map((service, i) => {
          const Icon = icons[service.icon] || RadioTower;
          return (
            <Reveal key={service.id} delay={(i % 3) * 0.08}>
              <div
                className="card-dark group relative h-full rounded-2xl p-8 overflow-hidden"
                data-testid={`service-card-${service.id}`}
              >
                <div className="absolute -right-10 -top-10 w-40 h-40 rounded-full bg-[#00D4FF]/0 group-hover:bg-[#00D4FF]/5 blur-2xl transition-all duration-500" />
                <div className="relative">
                  <div className="w-14 h-14 rounded-xl flex items-center justify-center bg-[#00D4FF]/10 border border-[#00D4FF]/20 mb-6 group-hover:bg-[#00D4FF] transition-colors duration-300">
                    <Icon className="w-7 h-7 text-[#00D4FF] group-hover:text-[#04121f] transition-colors duration-300" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">{service.title}</h3>
                  <p className="text-slate-400 leading-relaxed mb-6">{service.description}</p>
                  <a
                    href="#contact"
                    onClick={(e) => scrollTo(e, "#contact")}
                    className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#00D4FF] opacity-80 group-hover:opacity-100 transition-opacity"
                    data-testid={`service-learn-${service.id}`}
                  >
                    Learn More
                    <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                  </a>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
